import { Card, ClickableText, Icon, Text } from "@portal/components/primitives";

type IndemnitorRowProps = {
	name: string;
	email?: string | null;
	/** Set when the company has no address: the row links to where the underwriter adds it. */
	onAddAddress?: () => void;
};

export const IndemnitorRow = ({ name, email, onAddAddress }: IndemnitorRowProps) => (
	<Card elevation="raised" className="flex items-center px-4 py-3">
		<div className="flex items-center flex-1 gap-x-2.5 min-w-0">
			<Text type="body" color="primary" className="[text-box-trim:none]">
				{name}
			</Text>
			{email && (
				<Text type="body-strong" color="tertiary" className="[text-box-trim:none]">
					{email}
				</Text>
			)}
			{onAddAddress && (
				<span className="flex items-center gap-1" data-testid="indemnitor-missing-address">
					<Icon type="exclamation-triangle" color="warning" size="mini" className="shrink-0" />
					<ClickableText
						type="body"
						color="link"
						onClick={onAddAddress}
						data-testid="indemnitor-missing-address-action"
					>
						Add an address
					</ClickableText>
				</span>
			)}
		</div>
	</Card>
);
